import React from 'react';

import { Redirect, Switch } from 'react-router-dom';
import { ProtectedRoute } from 'src/components/ProtectedRoute';
import { VIEWER_ROLE_SET } from 'src/constants/role';
import { ROUTES } from 'src/constants/routes';

import { AmfMetrics } from './AmfMetrics';
import { AmuMetrics } from './AmuMetrics';
import { PrimeMetrics } from './PrimeMetrics';

export const Analytics: React.FC = () => {
    return (
        <Switch>
            <Redirect exact from={ROUTES.ANALYTICS.INDEX} to={ROUTES.ANALYTICS.LICENSING_KPI.AMU_METRICS} />
            <ProtectedRoute requiredRoleSet={VIEWER_ROLE_SET} path={ROUTES.ANALYTICS.LICENSING_KPI.AMU_METRICS}>
                <AmuMetrics />
            </ProtectedRoute>
            <ProtectedRoute requiredRoleSet={VIEWER_ROLE_SET} path={ROUTES.ANALYTICS.LICENSING_KPI.PRIME_METRICS}>
                <PrimeMetrics />
            </ProtectedRoute>
            <ProtectedRoute requiredRoleSet={VIEWER_ROLE_SET} path={ROUTES.ANALYTICS.LICENSING_KPI.AMF_METRICS}>
                <AmfMetrics />
            </ProtectedRoute>
        </Switch>
    );
};
